export default "__VITE_ASSET__Cii8ex0M__"